import { Link } from "react-router-dom";
import { ArrowLeft, Mail, Phone, MapPin } from "lucide-react";

export default function ImpressumPage() {
  return (
    <section className="relative pt-32 pb-24 md:pt-40 md:pb-32 bg-bone-100 min-h-[80vh]">
      <div aria-hidden className="absolute top-32 -left-20 w-[320px] h-[320px] rounded-full bg-sage-200/40 blur-3xl" />
      <div aria-hidden className="absolute top-60 -right-20 w-[260px] h-[260px] rounded-full bg-clay-200/30 blur-3xl" />

      <div className="relative max-w-3xl mx-auto px-6 lg:px-10">
        <nav className="flex items-center gap-2 font-mono-fine text-[11px] tracking-[0.2em] uppercase text-ink-500 mb-8" aria-label="Breadcrumb">
          <Link to="/" className="hover:text-ink-900 transition-colors">Start</Link>
          <span>›</span>
          <span className="text-sage-600">Impressum</span>
        </nav>

        <span className="font-mono-fine text-[11px] tracking-[0.28em] uppercase text-sage-600">
          Rechtliches
        </span>
        <h1 className="mt-4 font-display font-light text-4xl md:text-5xl lg:text-[4rem] leading-[1.02] tracking-[-0.035em] text-ink-900">
          Impressum
        </h1>
        <p className="mt-6 text-ink-700 leading-relaxed">
          Angaben gemäß § 5 TMG.
        </p>

        <div className="mt-12 space-y-6">
          <div className="p-7 bg-bone-50 border border-bone-300 rounded-[1.5rem]">
            <div className="font-mono-fine text-[10px] tracking-[0.22em] uppercase text-sage-600">
              Anbieter
            </div>
            <div className="mt-3 font-display text-2xl text-ink-900">
              Xenia Höfel
            </div>
            <div className="mt-4 flex items-start gap-3 text-ink-700">
              <MapPin strokeWidth={1.5} className="w-4 h-4 text-sage-600 mt-1 shrink-0" />
              <div>
                Belziger Straße 25b<br />
                14797 Kloster Lehnin<br />
                Deutschland
              </div>
            </div>
          </div>

          <div className="grid sm:grid-cols-2 gap-6">
            <a
              href="mailto:beratung@xeniahoefel.de"
              className="group p-7 bg-sage-100 hover:bg-sage-200/70 border border-sage-200 rounded-[1.5rem] transition-colors flex items-start gap-4"
            >
              <div className="w-11 h-11 rounded-full bg-sage-400 text-bone-50 flex items-center justify-center shrink-0">
                <Mail strokeWidth={1.75} className="w-4 h-4" />
              </div>
              <div>
                <div className="font-mono-fine text-[10px] tracking-[0.22em] uppercase text-sage-700">E-Mail</div>
                <div className="mt-1 font-display text-lg text-ink-900">beratung@xeniahoefel.de</div>
              </div>
            </a>
            <a
              href="tel:+4915156166703"
              className="group p-7 bg-clay-100 hover:bg-clay-200/70 border border-clay-200 rounded-[1.5rem] transition-colors flex items-start gap-4"
            >
              <div className="w-11 h-11 rounded-full bg-clay-400 text-bone-50 flex items-center justify-center shrink-0">
                <Phone strokeWidth={1.75} className="w-4 h-4" />
              </div>
              <div>
                <div className="font-mono-fine text-[10px] tracking-[0.22em] uppercase text-clay-600">Telefon</div>
                <div className="mt-1 font-display text-lg text-ink-900">+49 151 56166703</div>
              </div>
            </a>
          </div>

          <div className="p-7 bg-bone-50 border border-bone-300 rounded-[1.5rem] space-y-4 text-ink-700 text-[15px] leading-relaxed">
            <div>
              <div className="font-mono-fine text-[10px] tracking-[0.22em] uppercase text-sage-600 mb-2">
                Verantwortlich für den Inhalt (§ 55 Abs. 2 RStV)
              </div>
              Xenia Höfel · Belziger Straße 25b · 14797 Kloster Lehnin
            </div>
            <div>
              <div className="font-mono-fine text-[10px] tracking-[0.22em] uppercase text-sage-600 mb-2">
                Streitschlichtung
              </div>
              Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{" "}
              <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noreferrer" className="text-sage-600 link-underline">
                ec.europa.eu/consumers/odr
              </a>
              . Ich bin nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucher­schlichtungs­stelle teilzunehmen.
            </div>
            <div>
              <div className="font-mono-fine text-[10px] tracking-[0.22em] uppercase text-sage-600 mb-2">
                Haftung für Inhalte
              </div>
              Als Diensteanbieter bin ich gemäß § 7 Abs. 1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG bin ich als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen.
            </div>
            <div>
              <div className="font-mono-fine text-[10px] tracking-[0.22em] uppercase text-sage-600 mb-2">
                Urheberrecht
              </div>
              Die durch die Seitenbetreiberin erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Vervielfältigung, Bearbeitung und Verbreitung bedürfen der schriftlichen Zustimmung.
            </div>
          </div>
        </div>

        <Link
          to="/"
          className="mt-12 inline-flex items-center gap-2 text-[13px] tracking-[0.12em] uppercase font-mono-fine text-ink-900 link-underline"
        >
          <ArrowLeft strokeWidth={1.5} className="w-4 h-4" /> Zurück zur Startseite
        </Link>
      </div>
    </section>
  );
}
